<div class="data-grid-container">

  <!-- ========== MODO FLIP: Toolbar "Voltar para a grade" ========== -->
  <div class="flip-toolbar" *ngIf="isFlipEditing && viewMode === 'flip'">
    <button 
      nz-button 
      nzType="default"
      (click)="exitFlipMode()"
      nz-tooltip="Voltar para a grade">
      <i nz-icon nzType="arrow-left" nzTheme="outline"></i>
      Voltar para a grade
    </button>
    <nz-tag [nzColor]="flipEditingMode === 'adding' ? 'green' : 'blue'">
      {{ flipEditingMode === 'adding' ? 'Incluindo novo registro' : 'Editando registro' }}
    </nz-tag>
  </div>

  <!-- ========== FACE 1: Grade (escondida no flip quando editando) ========== -->
  <div [hidden]="(isFlipEditing && viewMode === 'flip') || suppressGridFaceForInitialAutoAdd">

    <!-- Barra de ferramentas com pesquisa global -->
    <div class="toolbar" *ngIf="enableFilters || enableCRUD">
      <div class="toolbar-left">
        <!-- Pesquisa global (se filtros habilitados) -->
        <nz-input-group 
          *ngIf="enableFilters" 
          [nzPrefix]="prefixIconSearch" 
          style="width: 300px;"
        >
          <input 
            nz-input 
            [placeholder]="'builderScreen.dataGrid.placeholder.search' | translateTA" 
            (input)="onGlobalFilterChange($any($event.target).value)"
          />
        </nz-input-group>
        <ng-template #prefixIconSearch>
          <i nz-icon nzType="search"></i>
        </ng-template>
      </div>
      
      <div class="toolbar-right">
        <!-- Botão Editar (Master-Detail / Flip / Drawer) -->
        <button 
          *ngIf="enableMasterDetail && selectedRows.size > 0 && !isNestedGrid()" 
          nz-button 
          nzType="default"
          (click)="openMasterDetailPanel()"
          [nz-tooltip]="'builderScreen.dataGrid.tooltip.edit' | translateTA">
          <i nz-icon nzType="form" nzTheme="outline"></i>
          {{ 'builderScreen.dataGrid.button.edit' | translateTA }}
        </button>
        
        <!-- Botão adicionar (se CRUD habilitado) -->
        <button 
          *ngIf="enableCRUD" 
          nz-button 
          nzType="primary"
          (click)="onAddRow()"
          [nz-tooltip]="'builderScreen.dataGrid.tooltip.add' | translateTA">
          <i nz-icon nzType="plus"></i>
          {{ 'builderScreen.dataGrid.button.add' | translateTA }}
        </button>
      </div>
    </div>
    
    <!-- Tabela com scroll horizontal -->
    <div class="table-wrapper" *ngIf="tableVisible">
      <nz-table
        [nzData]="displayData"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        [nzSize]="'middle'"
        [nzBordered]="true"
        [nzScroll]="scrollConfig"
        class="data-grid-table"
      >
      <thead>
        <tr>
          <!-- Coluna de seleção -->
          <th *ngIf="selectionMode !== 'none'" nzWidth="50px">
            <i nz-icon nzType="check-square"></i>
          </th>
          
          <!-- Colunas de dados -->
          <th 
            *ngFor="let column of columns"
            [nzWidth]="column.width"
            [class.sortable]="column.sortable"
            (click)="column.sortable ? onSortChange(column) : null"
          >
            <div class="column-header">
              <span>{{ column.header }}</span>
              <i 
                *ngIf="column.sortable && getSortIcon(column)" 
                nz-icon 
                [nzType]="getSortIcon(column)"
                class="sort-icon"
              ></i>
            </div>
          </th>
          
          <!-- Coluna de ações (se CRUD habilitado) -->
          <th *ngIf="enableCRUD" nzWidth="120px">Ações</th>
        </tr>
      </thead>
      
      <tbody>
        <tr 
          *ngFor="let row of displayData; let rowIndex = index; trackBy: trackByRowIndex"
          [class.selected]="isRowSelected(row)"
          (click)="onRowSelect(row, $event, rowIndex)"
          (dblclick)="enableMasterDetail && (viewMode === 'flip' || viewMode === 'drawer') ? onEditRow(row, rowIndex) : null"
        >
          <!-- Checkbox de seleção -->
          <td *ngIf="selectionMode !== 'none'">
            <label nz-checkbox [nzChecked]="isRowSelected(row)" (nzCheckedChange)="onRowSelect(row, $event, rowIndex)"></label>
          </td>
          
          <!-- Células de dados -->
          <td *ngFor="let column of columns; let colIndex = index"
              [class.spreadsheet-cell]="viewMode === 'spreadsheet'"
              [class.spreadsheet-active]="isCellActive(rowIndex, colIndex)"
              (click)="viewMode === 'spreadsheet' ? activateCell(rowIndex, colIndex) : null">

            <!-- ========== MODO SPREADSHEET: Célula ativa (editável) ========== -->
            <ng-container *ngIf="viewMode === 'spreadsheet' && isCellActive(rowIndex, colIndex)">
              <div class="cell-content editable" [ngSwitch]="column.type" (click)="$event.stopPropagation()">
                <nz-switch
                  *ngSwitchCase="'boolean'"
                  [ngModel]="resolveColumnValue(row, column)"
                  (ngModelChange)="onCellEdit(row, column, $event, rowIndex)"
                  (keydown)="onSpreadsheetKeydown($event, rowIndex, colIndex)"
                ></nz-switch>

                <nz-input-number
                  *ngSwitchCase="'number'"
                  [ngModel]="resolveColumnValue(row, column)"
                  (ngModelChange)="onCellEdit(row, column, $event, rowIndex)"
                  (keydown)="onSpreadsheetKeydown($event, rowIndex, colIndex)"
                  class="cell-input spreadsheet-cell-input"
                  [attr.data-row]="rowIndex"
                  [attr.data-col]="colIndex"
                  style="width: 100%"
                ></nz-input-number>

                <!-- Search inline (spreadsheet) -->
                <nz-select
                  *ngSwitchCase="'search'"
                  nzShowSearch
                  nzAllowClear
                  nzServerSearch
                  [nzLoading]="isSearchColumnLoading(column)"
                  [ngModel]="resolveColumnValue(row, column)"
                  (nzOnSearch)="onSearchColumnSearch(column, $event)"
                  (ngModelChange)="onSearchCellSelect(row, column, $event, rowIndex)"
                  nzSize="small"
                  style="width: 100%"
                  nzPlaceHolder="Buscar..."
                >
                  <nz-option
                    *ngFor="let opt of getSearchColumnOptions(column)"
                    [nzValue]="column.showKey ? {key: opt.key, value: opt.value} : opt.key"
                    [nzLabel]="column.showKey ? (opt.key + ' - ' + opt.value) : opt.value"
                  ></nz-option>
                </nz-select>

                <!-- Dropdown inline (spreadsheet) -->
                <nz-select
                  *ngSwitchCase="'dropdown'"
                  [ngModel]="resolveColumnValue(row, column)"
                  (ngModelChange)="onCellEdit(row, column, $event, rowIndex)"
                  nzSize="small"
                  style="width: 100%"
                  [nzShowSearch]="column.showSearch || false"
                  nzPlaceHolder="Selecione..."
                >
                  <nz-option
                    *ngFor="let opt of column.options || []"
                    [nzValue]="opt.value"
                    [nzLabel]="opt.label"
                  ></nz-option>
                </nz-select>

                <input
                  *ngSwitchDefault
                  nz-input
                  [ngModel]="resolveColumnValue(row, column)"
                  (ngModelChange)="onCellEdit(row, column, $event, rowIndex)"
                  (keydown)="onSpreadsheetKeydown($event, rowIndex, colIndex)"
                  (blur)="deactivateCell()"
                  class="cell-input spreadsheet-cell-input"
                  [attr.data-row]="rowIndex"
                  [attr.data-col]="colIndex"
                  placeholder="..."
                />
              </div>
            </ng-container>

            <!-- ========== MODO SPREADSHEET: Célula inativa (somente leitura) ========== -->
            <ng-container *ngIf="viewMode === 'spreadsheet' && !isCellActive(rowIndex, colIndex)">
              <div class="cell-content spreadsheet-readonly" [ngSwitch]="column.type">
                <span *ngSwitchCase="'boolean'" class="boolean-cell">
                  <nz-tag [nzColor]="resolveColumnValue(row, column) ? 'green' : 'red'" nzSize="small">
                    {{ resolveColumnValue(row, column) ? 'Sim' : 'Não' }}
                  </nz-tag>
                </span>
                <span *ngSwitchCase="'search'">{{ resolveSearchDisplay(resolveColumnValue(row, column), column) }}</span>
                <span *ngSwitchCase="'dropdown'">{{ getDropdownLabel(resolveColumnValue(row, column), column) }}</span>
                <span *ngSwitchDefault>{{ resolveColumnValue(row, column) }}</span>
              </div>
            </ng-container>

            <!-- ========== MODOS NORMAIS (inline/flip/drawer): Comportamento original ========== -->
            <ng-container *ngIf="viewMode !== 'spreadsheet'">
              <!-- Células Editáveis -->
              <div 
                *ngIf="column.editable" 
                class="cell-content editable" 
                [ngSwitch]="column.type"
                (click)="$event.stopPropagation()">
                <input 
                  *ngSwitchCase="'text'"
                  nz-input
                  [ngModel]="resolveColumnValue(row, column)"
                  (ngModelChange)="onCellEdit(row, column, $event, rowIndex)"
                  (focus)="onCellFocus()"
                  (blur)="onCellBlur()"
                  (click)="$event.stopPropagation()"
                  placeholder="Digite..."
                  class="cell-input"
                />
                
                <nz-input-number
                  *ngSwitchCase="'number'"
                  [ngModel]="resolveColumnValue(row, column)"
                  (ngModelChange)="onCellEdit(row, column, $event, rowIndex)"
                  (click)="$event.stopPropagation()"
                  class="cell-input"
                  style="width: 100%"
                ></nz-input-number>
                
                <nz-switch
                  *ngSwitchCase="'boolean'"
                  [ngModel]="resolveColumnValue(row, column)"
                  (ngModelChange)="onCellEdit(row, column, $event, rowIndex)"
                  (click)="$event.stopPropagation()"
                ></nz-switch>

                <!-- Search inline com popover -->
                <nz-select
                  *ngSwitchCase="'search'"
                  nzShowSearch
                  nzAllowClear
                  nzServerSearch
                  [nzLoading]="isSearchColumnLoading(column)"
                  [ngModel]="resolveColumnValue(row, column)"
                  (nzOnSearch)="onSearchColumnSearch(column, $event)"
                  (ngModelChange)="onSearchCellSelect(row, column, $event, rowIndex)"
                  (nzOpenChange)="$event ? onSearchColumnSearch(column, '') : null"
                  (click)="$event.stopPropagation()"
                  nzSize="small"
                  style="width: 100%"
                  nzPlaceHolder="Buscar..."
                >
                  <nz-option
                    *ngFor="let opt of getSearchColumnOptions(column)"
                    [nzValue]="column.showKey ? {key: opt.key, value: opt.value} : opt.key"
                    [nzLabel]="column.showKey ? (opt.key + ' - ' + opt.value) : opt.value"
                  ></nz-option>
                </nz-select>

                <!-- Dropdown inline -->
                <nz-select
                  *ngSwitchCase="'dropdown'"
                  [ngModel]="resolveColumnValue(row, column)"
                  (ngModelChange)="onCellEdit(row, column, $event, rowIndex)"
                  (click)="$event.stopPropagation()"
                  nzSize="small"
                  style="width: 100%"
                  [nzShowSearch]="column.showSearch || false"
                  nzPlaceHolder="Selecione..."
                >
                  <nz-option
                    *ngFor="let opt of column.options || []"
                    [nzValue]="opt.value"
                    [nzLabel]="opt.label"
                  ></nz-option>
                </nz-select>
                
                <input 
                  *ngSwitchDefault
                  nz-input
                  [ngModel]="resolveColumnValue(row, column)"
                  (ngModelChange)="onCellEdit(row, column, $event, rowIndex)"
                  (focus)="onCellFocus()"
                  (blur)="onCellBlur()"
                  (click)="$event.stopPropagation()"
                  placeholder="Digite..."
                  class="cell-input"
                />
              </div>
              
              <!-- Células Somente Leitura -->
              <div *ngIf="!column.editable" class="cell-content" [ngSwitch]="column.type">
                <span *ngSwitchCase="'text'">
                  {{ resolveColumnValue(row, column) }}
                </span>
                
                <span *ngSwitchCase="'number'" class="number-cell">
                  {{ resolveColumnValue(row, column) }}
                </span>
                
                <span *ngSwitchCase="'date'" class="date-cell">
                  {{ resolveColumnValue(row, column) }}
                </span>
                
                <span *ngSwitchCase="'boolean'" class="boolean-cell">
                  <nz-tag [nzColor]="resolveColumnValue(row, column) ? 'green' : 'red'">
                    {{ resolveColumnValue(row, column) ? 'Sim' : 'Não' }}
                  </nz-tag>
                </span>

                <span *ngSwitchCase="'search'" class="search-cell">
                  {{ resolveSearchDisplay(resolveColumnValue(row, column), column) }}
                </span>

                <span *ngSwitchCase="'dropdown'" class="dropdown-cell">
                  <nz-tag nzColor="blue" *ngIf="resolveColumnValue(row, column) != null">
                    {{ getDropdownLabel(resolveColumnValue(row, column), column) }}
                  </nz-tag>
                </span>
                
                <span *ngSwitchDefault>
                  {{ resolveColumnValue(row, column) }}
                </span>
              </div>
            </ng-container>
          </td>
          
          <!-- Botões de ação (se CRUD habilitado) -->
          <td *ngIf="enableCRUD">
            <div class="action-buttons">
              <button 
                nz-button 
                nzType="link" 
                nzSize="small"
                nz-tooltip="Editar"
                (click)="onEditRow(row, rowIndex); $event.stopPropagation()"
              >
                <i nz-icon nzType="edit"></i>
              </button>
              <button 
                nz-button 
                nzType="link" 
                nzSize="small" 
                nzDanger
                nz-tooltip="Excluir"
                (click)="onDeleteRow(row, rowIndex, $event)"
              >
                <i nz-icon nzType="delete"></i>
              </button>
            </div>
          </td>
        </tr>
        
        <!-- Linha vazia quando não há dados -->
        <tr *ngIf="displayData.length === 0">
          <td [attr.colspan]="columns.length + (selectionMode !== 'none' ? 1 : 0) + (enableCRUD ? 1 : 0)">
            <nz-empty [nzNotFoundContent]="'Nenhum dado encontrado'"></nz-empty>
          </td>
        </tr>
      </tbody>
    </nz-table>
    </div><!-- /.table-wrapper -->
    
    <!-- Paginação customizada -->
    <div class="pagination-container" *ngIf="enablePagination && totalPages > 1">
      <div class="pagination-info">
        Página {{ currentPage }} de {{ totalPages }}
        ({{ originalData.length }} registros no total)
      </div>
      <div class="pagination-buttons">
        <button 
          nz-button 
          nzSize="small"
          [disabled]="currentPage === 1"
          (click)="onPageChange(currentPage - 1)"
        >
          <i nz-icon nzType="left"></i>
          Anterior
        </button>
        
        <button 
          *ngFor="let page of getPagesArray()"
          nz-button 
          nzSize="small"
          [nzType]="page === currentPage ? 'primary' : 'default'"
          (click)="onPageChange(page)"
          class="page-number"
        >
          {{ page }}
        </button>
        
        <button 
          nz-button 
          nzSize="small"
          [disabled]="currentPage === totalPages"
          (click)="onPageChange(currentPage + 1)"
        >
          Próxima
          <i nz-icon nzType="right"></i>
        </button>
      </div>
    </div>

  </div><!-- /FACE 1: Grade -->

</div>
